import { render, staticRenderFns } from "./WidgetAddOnSizeRecommendationPopup.vue?vue&type=template&id=24a1f89e&scoped=true"
import script from "./WidgetAddOnSizeRecommendationPopup.vue?vue&type=script&lang=js"
export * from "./WidgetAddOnSizeRecommendationPopup.vue?vue&type=script&lang=js"
import style0 from "./WidgetAddOnSizeRecommendationPopup.vue?vue&type=style&index=0&id=24a1f89e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a1f89e",
  null
  
)

export default component.exports